
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll() {
        return axios.get(`${API_URL}/payments`, { headers: authHeader() });
    },
    create() {
        return axios.post(`${API_URL}/payments`, { headers: authHeader() });
    },
    get() {
        return axios.get(`${API_URL}/payments/1`, { headers: authHeader() });
    },
   
};